import { gql } from '@apollo/client';

export const DELETE_ARBEITSBEREICH_STATION = gql`
  mutation mitarbeiter_deleteArbeitsbereichStation(
    $arbeitsbereichStationId: String!
    $fristId: String
    $standortwechselId: String
  ) {
    mitarbeiter_deleteArbeitsbereichStation(
      arbeitsbereichStationId: $arbeitsbereichStationId
      fristId: $fristId
      standortwechselId: $standortwechselId
    ) {
      success {
        arbeitsbereichStationId
        details
        fristResult {
          error {
            message
          }
          success
        }
      }
      error {
        message
      }
    }
  }
`;
